import React, { Component } from 'react';
import getLabel from './../../utils/labels'
import person from './../../globals/images/actors/Arthur.png';
import styles from './meetingAlert.module.scss';

class MeetingAlert extends Component {
    constructor(props) {
        super(props);
        this.countDownTimer = null;
        this.state = {
            countDown: 5
        }
    }

    componentDidMount = () => {
        this.startCountDown();
    }

    startCountDown = () => {
        this.countDownTimer = setInterval(() => {
            if (this.state.countDown > 0) {
                this.setState({
                    countDown: this.state.countDown - 1
                })
            } else {
                this.props.hideMeetingNotification()
            }
        }, 1000);
        return this.countDownTimer;
    }


    render() {
        return (
            <div className={styles['meeting-container']}>
                <div className={styles.meetingtitle}>
                    {getLabel('label_team_meeting')}
                </div>
                <div className={styles['timer-content']}>
                    <img src={person} className={styles.meetingimage} />
                    <div className={styles.text}>{getLabel('label_meeting_starts_in')} </div>
                    <p className={styles.timer}>
                        {Math.floor(this.props.timeLeft / 60000)}
                    </p>
                    <div className={styles.text}>{getLabel('label_meeting_time_min')} </div>
                </div>
            </div>
        )
    }
}

export default MeetingAlert;


// WEBPACK FOOTER //
// /src/components/meetingAlert/MeetingAlert.js